import React from "react";
import { User } from "firebase/auth";
import { AuthUser } from "@hooks";

interface IAuthContext {
  authUser: AuthUser | null;
  user: User | null;
  setUser: (user: User) => void;
  clearUser: () => void;
}

const AuthContext: React.Context<IAuthContext> =
  React.createContext<IAuthContext>({
    authUser: null,
    user: null,
    setUser: () => {},
    clearUser: () => {},
  });

export { AuthContext, type IAuthContext };
